export enum RelatedTypeEnum {
  CLICK = 'click',
  ADD2CART = 'add2cart',
  CHECKOUT = 'checkout',
}
